import { styled } from '@mui/material/styles';

export const StyledBulkContainerDiv = styled('div')<{
  listHeight: number;
}>`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  width: 100%;

  height: ${({ listHeight }) => listHeight}px;
  background: ${({ theme }) => theme.palette.background.boxLight};
  padding: ${({ theme }) => theme.spacing(1.5)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-bottom: none;
`;
